/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `website` - Website
 * * `agent` - Agent
 * * `broker` - Broker
 */
export enum DocumentSource {
  WEBSITE = 'website',
  AGENT = 'agent',
  BROKER = 'broker',
}
